import Abstract from "../../abstract-view/abstract.js";

export default class Button extends Abstract {
  constructor(element) {
    super();

    this._element = element;

    this._previousElement = null;
  }

  setPreviousElement() {
    if (!this._previousElement) {
      this._previousElement = this._element.previousElementSibling;
    }
  }

  getPreviousElement() {
    return this._previousElement;
  }
}
